import { useState, useEffect } from 'react';
import { getScrollOffset } from 'utils/get-scroll-offset';

export const useScrolled = (visiblePosition: number) => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    let frameId: number | undefined;

    const handleScroll = () => {
      frameId = window.requestAnimationFrame(() => {
        const offset = getScrollOffset();
        setScrolled(offset >= visiblePosition);
      });
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });

    const observer = new MutationObserver(() => {
      handleScroll();
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['style', 'class'],
    });

    return () => {
      if (frameId) {
        window.cancelAnimationFrame(frameId);
      }
      window.removeEventListener('scroll', handleScroll);
      observer.disconnect();
    };
  }, [visiblePosition]);

  return {
    scrolled,
  };
};
